import { FormLabel, FormLabelProps } from '@chakra-ui/react';
import React from 'react';

import { CmText, CmTooltip, QuestionIcon } from '@/components/uiParts';

type Props = {
  isRequired?: boolean;
  question?: string;
} & FormLabelProps;

export const CmFormLabelWithQuestionIcon: React.FC<Props> = ({
  children,
  id,
  isRequired = false,
  question,
  ...rest
}) => {
  return (
    // @ts-ignore TS2590
    <FormLabel mr={0} htmlFor={id} {...rest}>
      {children}
      {isRequired && (
        <CmText as="span" color="red" fontSize="14px" verticalAlign="super">
          *
        </CmText>
      )}
      {question && (
        <CmTooltip label={question}>
          <QuestionIcon
            color="gray"
            size="md"
            verticalAlign="baseline"
            marginLeft="3px"
            fontSize="small"
          />
        </CmTooltip>
      )}
    </FormLabel>
  );
};
